import { CheckCircle, Copy } from '@tencent/odc-iconpack';
import { message } from 'odc-shared/components';
import React, { useRef, useState } from 'react';

import { copyText } from '@src/utils/common';

const CopyButton: React.FC<{ code: string }> = ({ code }) => {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef<any>(null);

  const handleCopy = () => {
    if (copied) return;
    try {
      copyText(code);
      setCopied(true);
      // message.success('Code copied to clipboard!');
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => setCopied(false), 2000);

    } catch (err) {
      message.error('Failed to copy code');
    }
  };

  return (
    <button
      className="odc-copy-button"
      onClick={handleCopy}
      title={copied ? 'Copied!' : 'Copy code'}
    >
      {copied ? (
        <CheckCircle />
      ) : (
        <Copy />
      )}
    </button>
  );
};

export default CopyButton;